"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zappy = void 0;
exports.zappy = {
    router: '0xB9239AF0697C8efb42cBA3568424b06753c6da71',
    masterchef: '0x3D2c6bCED5f50f5412234b87fF0B445aBA4d10e9',
};
